import React, { useState, useRef, useContext } from "react";
import styled from "styled-components";
import Modal from 'react-bootstrap/Modal';
import TableListSallesOrderPrint from "../TableListSallesOrderPrint";
import { useReactToPrint } from 'react-to-print';
import printIcon from '../../images/svg/printer 1.svg'
import printIconWhite from '../../images/svg/printer-white.svg'
import { RequestsContext } from "../../context/requests";
const CardWrapper = styled.div`
    margin-left: 0.5rem;
`
const Button = styled.button`
    border:none;
    background-color: white;
    font-family: "Poppins";
    font-weight: 500;
`
const ButtonSecondary = styled.button`
    border:none;
    background-color: #0050dc;
    border-radius: 19px;
    width: 119px;
    height: 31px;
    font-size: 1.0rem;
    color: white;
    font-family: "Poppins";
    font-weight: 500;
`
const Image = styled.img`
    width: 15px;
    margin-right: 0.4rem;

`
const BoxTexts = styled.div`
    margin-top: 1.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .textPrimary{
        font-size: 1.2rem;
        font-family: "Poppins";
        font-weight: 500;
        height: 18px;
    }

    .textSecondary{
        font-size: 1.1rem;
        font-family: "Poppins";
        font-weight: 500;
    }

`

const PrintTiny = ({ structure }) => {
    const {typeFilter} = useContext(RequestsContext)
    const [showModal, setShowModal] = useState(false)
    const contentRef = useRef(null);


    const reactToPrintFn = useReactToPrint({ contentRef });


    return (


        <CardWrapper>

            <Button onClick={() => setShowModal(true)}>
                <Image src={printIcon} />
                Imprimir
            </Button>


            <Modal
                onHide={() => setShowModal(false)}
                show={showModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <ButtonSecondary onClick={() => reactToPrintFn()}>
                            <Image src={printIconWhite} />
                            Imprimir

                        </ButtonSecondary>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body ref={contentRef} >
                    <BoxTexts>
                    <p className="textPrimary">{localStorage.getItem("@USER_NAME")}</p>
                    <p className="textSecondary">Relatório de Pedidos de Vendas</p>
                    </BoxTexts>
                    <TableListSallesOrderPrint structure={structure} />

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShowModal(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

        </CardWrapper>


    )
}

export default PrintTiny